import { render, staticRenderFns } from "./BriefAreaChart.vue?vue&type=template&id=056da9b1&scoped=true"
import script from "./BriefAreaChart.vue?vue&type=script&lang=js"
export * from "./BriefAreaChart.vue?vue&type=script&lang=js"
import style0 from "./BriefAreaChart.vue?vue&type=style&index=0&id=056da9b1&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "056da9b1",
  null
  
)

export default component.exports